import { type InputHTMLAttributes } from "react";
import { Icon, type IconName } from "./icons";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: IconName;
}

export function Input({ leadingIcon, className = "", ...rest }: InputProps) {
  if (leadingIcon) {
    return (
      <div className="input-kit-wrap">
        <span className="input-leading-icon">
          <Icon name={leadingIcon} size={16} />
        </span>
        <input className={`input-kit with-icon ${className}`.trim()} {...rest} />
      </div>
    );
  }
  return <input className={`input-kit ${className}`.trim()} {...rest} />;
}
